/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';

import { Alert } from '@zapier/design-system';

const parsedTime = Date.now();
export const shouldRender = () => {
  const hoursElapsed = (Date.now() - parsedTime) / 1000 / 60 / 60;
  return hoursElapsed > 24;
};

export const Component = function RefreshRequired() {
  return (
    <Alert
      ariaLive="polite"
      layout="banner"
      title="A new version of Zapier is available"
      type="info"
    >
      <p>
        <button
          type="button"
          css={{ textDecoration: 'underline' }}
          onClick={() => window.location.reload()}
        >
          Refresh now
        </button>{' '}
        to get the latest version
      </p>
    </Alert>
  );
};
